import React from "react";

import Collapse, { CollapseItem } from "../../components/collapse/Collapse";

const CollapseLeasingFAQ = ({ plain }) => (
  <Collapse className={`${plain ? "plain-" : ""}collapse`}>
    <CollapseItem
      plain={plain}
      title="Welche Voraussetzungen muss ich erfüllen, um einen Leasingvertrag abschließen zu können?"
    >
      <p>
        <b>Privatkunden</b>
        <br />
        Als Privatperson sollten Sie keinen negativen Schufa-Eintrag haben und
        ein ausreichend hohes Nettoeinkommen nachweisen können. Bei befristeten
        Arbeitsverträgen muss dieser mindestens bis Ende der Leasingzeit
        bestehen.
        <br />
        <br />
        <b>Gewerbekunden</b>
        <br />
        Um einen Leasingvertrag ohne weitere Sicherheiten (Bürge, Kaution oder
        Anzahlung) abschließen zu können, muss Ihr Unternehmen mindestens 1 Jahr
        bestehen. Bei Kapitalgesellschaften gegebenenfalls länger.
      </p>
    </CollapseItem>

    <CollapseItem
      plain={plain}
      title="Sind Versicherung, KFZ-Steuer und Wartung bereits in der Leasingrate enthalten?"
    >
      <p>
        Falls im Angebot nicht anders angegeben, enthält die Leasingrate
        lediglich die reine Nutzungsgebühr für das Fahrzeug. Versicherung,
        KFZ-Steuer etc. sind dann nicht in der monatlichen Rate enthalten.
      </p>
    </CollapseItem>

    <CollapseItem plain={plain} title="Wann kann ich mein Fahrzeug abholen?">
      <p>
        In der Regel können Sie Ihr Fahrzeug 7 - 14 Tage nach Vertragsschluss
        abholen.
      </p>
    </CollapseItem>
    <CollapseItem plain={plain} title="Wo hole ich mein Fahrzeug ab?">
      <p>
        Den Fahrzeugstandort können Sie aus dem Datenblatt des jeweiligen
        Angebots entnehmen. Auch eine Lieferung des Fahrzeugs ist gegen eine
        Gebühr möglich.
      </p>
    </CollapseItem>
    <CollapseItem
      plain={plain}
      title="Wie funktioniert die Rückgabe nach Ende der Leasingzeit?"
    >
      <p>
        Nach Ablauf der Leasingzeit bringen Sie das Fahrzeug wieder zurück zum
        Händler. Dort wird der Zustand des Wagens durch einen unabhängigen
        KFZ-Sachverständigen überprüft. Altersgemäße Gebrauchsspuren werden
        natürlich nicht in Rechnung gestellt. Nur bei überdurchschnittlicher
        Abnutzung, gemessen am Alter und KM-Stand des Wagens, werden
        Reparaturkosten berechnet (z.B. tiefe Lackkratzer, Beschädigung der
        Felgen, extreme Steinschläge).
        <br />
        Außerdem werden Mehr- oder Minderkilometer je nach Vertragsbestimmungen
        abgerechnet.
      </p>
    </CollapseItem>
  </Collapse>
);

export default CollapseLeasingFAQ;
